import type { ReactNode } from "react";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { ListItemButton, ListItemIcon } from "@mui/material";
import { useNavigate } from "@tanstack/react-router";

export type MenuItemProps = {
    icon: ReactNode;
    text: ReactNode;
    href?: string;
    active?: boolean;
};

export const MenuItem = ({ icon, text, href, active }: MenuItemProps) => {
    const navigate = useNavigate();

    if (!href) return null;

    const handleNavigate = (event: React.MouseEvent) => {
        if (event.ctrlKey || event.metaKey) {
            window.open(href, "_blank");
        } else {
            navigate({
                to: href,
            });
        }
    };

    return (
        <ListItem disablePadding>
            <ListItemButton onClick={handleNavigate} selected={active}>
                <ListItemIcon>{icon}</ListItemIcon>
                <ListItemText primary={text} disableTypography />
            </ListItemButton>
        </ListItem>
    );
};
